/**
 * Преобразует объект в строку с параметрами для GET запроса
 */
const makeStrForGetReqFromObj = (obj) => {
    let str = '';
    for (var key in obj) {
        str += (str) ? `&${key}=${obj[key]}` : `?${key}=${obj[key]}`;
    }
    return str;
}

/**
 * Проверяет является ли строка ссылкой
 * @param string
 * @returns {boolean}
 */
const isValidHttpUrl = (string) => {
    let url;
    try {
        url = new URL(string);
    } catch (_) {
        return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
}

const hasIsProp = (ob, prop) => ob.hasOwnProperty(prop);

const isTrueProp = (ob, prop) => !!(ob.hasOwnProperty(prop) && ob[prop]);

const isScrollable = (node) => {
    let overflowY = window.getComputedStyle(node)['overflow-y'];
    let overflowX = window.getComputedStyle(node)['overflow-x'];
    return {
        vertical: (overflowY === 'scroll' || overflowY === 'auto') && node.scrollHeight > node.clientHeight,
        horizontal: (overflowX === 'scroll' || overflowX === 'auto') && node.scrollWidth > node.clientWidth,
    };
}

const toTree = (data) => {
    data.forEach((item) => {
        delete item.children;
    });
    let map = {};
    data.forEach((item) => map[item.value] = item);
    let val = [];
    data.forEach((item) => {
        const parent = map[item.pid];
        if (parent) {
            (parent.children || (parent.children = [])).push(item);
        } else {
            val.push(item);
        }
    });
    return val;
}

const contains = (arr, elem) => arr.indexOf(elem) != -1;

export {contains, toTree, makeStrForGetReqFromObj, isValidHttpUrl, hasIsProp, isScrollable, isTrueProp};